// Step 4
// Confirmation Step

import React from "react";
import ApiService from "../../services/api.service";
import TagManager from "react-gtm-module";
import Helper, { isLocalhost } from "../../common/helper";
import { commissionJunctionRules } from "../../common/commission-junction-rules";
import OrderConfirmationBox from "../UI/order-confirmation-box";

export default function ConfirmationStep({
  selectMembership,
  isExpress,
  isQBR,
  currentStep,
  termsLink,
  languages,
  locationData,
  stepNo,
  localStorageDatas,
  couponObj,
  isUserLogged,
  category,
  businessCategories,
}) {
  const productArr = [];

  var getCoupon = null;
  let PWP = null;
  productArr.push(localStorageDatas);

  function redirectConfirmation() {
    const isLocal = isLocalhost();
    const { urlRoot } = Helper.getUrl();

    if (isLocal) {
      return window.location.reload();
    }
    window.location.href = urlRoot;
    return;
  }

  if (currentStep !== stepNo) {
    return null;
  }

  window.sessionStorage.removeItem("selected_membership");
  window.sessionStorage.removeItem("personal_details");
  window.sessionStorage.removeItem("address_details");
  window.sessionStorage.removeItem("secondary_selected_membership");
  window.sessionStorage.removeItem("secondary_personal_details");
  window.sessionStorage.removeItem("secondary_address_details");
  Helper.deleteCookie("coupon");

  var currencyText = "";

  let item_selected = localStorageDatas.members?.[0].selected_product;

  if (Object.keys(item_selected).length !== 0) {
    if (
      localStorageDatas &&
      localStorageDatas.members.length > 0 &&
      item_selected &&
      item_selected[0].currency_text
    ) {
      currencyText = item_selected[0].currency_text;
    }

    getCoupon = Helper.checkCoupon(item_selected[0], couponObj);
    PWP = Helper.newpwpCheck(
      item_selected[0],
      isUserLogged,
      locationData,
      businessCategories
    );
  }

  var totalnum = 0;
  var totalGst = 0;

  if (Object.keys(item_selected).length !== 0) {
    for (var i = 0; i < localStorageDatas.members.length; i++) {
      let price = "";
      let gst = "";
      if (
        localStorageDatas.members[i].selected_product &&
        localStorageDatas.members[i].selected_product[0].purchase_price
      ) {
        price = parseFloat(
          localStorageDatas.members[i].selected_product[0].purchase_price
        );
        gst = parseFloat(
          localStorageDatas.members[i].selected_product[0].tax_amt
        );
      }
      totalnum += price;
      totalGst += gst;
    }
    var totalAmt = totalnum + totalGst;
  }
  var showTotalPrice = getCoupon.exists || PWP.exists ? false : true;
  startGtmTransaction();

  async function startGtmTransaction() {
    let ssoUserData = await ApiService.userdata();
    const businessCategory =
      localStorageDatas.members[0].selected_product[0].business_category_id;
    const paymentType = localStorageDatas.paymentType;

    if (window.dataLayer.filter((a) => a.event === "purchase").length < 1) {
      const transactionPayload = {
        currencyCode: locationData.currency,
        membershipType: ssoUserData ? ssoUserData.card.cardLabel : category,
        paymentMethod: paymentType,
        transactionId: localStorageDatas.transactionId,
        transactionTax: "",
        transactionTotal: totalAmt,
        products: productsForGtm(),
        coupon_code: getCoupon.exists ? getCoupon.coupon_code_id : "",
        countryCode: Helper.lookupCurrentCountry().code,
        businessCategory,
        salesType: commissionJunctionRules(locationData, paymentType),
      };

      TagManager.dataLayer(Helper.gtmTransaction(transactionPayload));
    }
  }

  function productsForGtm() {
    let products = [];
    for (let i = 0; i < localStorageDatas.members.length; i++) {
      let member = localStorageDatas.members[i];
      products.push({
        id: member.selected_product[0].item_group_id,
        name: member.selected_product[0].item_group_description,
        price:
          parseFloat(member.selected_product[0].purchase_price) +
          parseFloat(
            member.selected_product[0].tax_amt ||
              member.selected_product[0].tax_amount
          ),
        price_no_tax: parseFloat(member.selected_product[0].purchase_price),
        category: member.selected_product[0].item_group_name,
      });
    }

    return products;
  }
  console.log(item_selected[0].item_group_description);
  return (
    <div className="flex justify-center xs:mt-4">
      <OrderConfirmationBox
        membership={item_selected[0].item_group_description}
        memberServiceLink="https://accorplushelp.zendesk.com/hc/en-au"
        onClick={redirectConfirmation}
        languages={languages}
      />
    </div>
  );
}
